module.exports = __webpack_public_path__ + "static/media/2.5008e7f6.jpg";